module.exports = __webpack_public_path__ + "img/pic5.911897e7.png";